<div id="deviceManagement">
  <div class="widget flex flex-column p-4 gap-4" id="deviceList">
    @if (loadingDevices()) {
      <div class="h-full flex align-items-center justify-content-center widget">
        <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
      </div>
    } @else if (devices() !== null) {
      <p-table
        [columns]="devicesCols"
        [value]="devices()!"
        class="mb-3"
        id="devicesTable"
        [scrollable]="true"
        scrollHeight="flex"
        #deviceTable
      >
        <ng-template #caption>
          <div class="flex w-full justify-content-between align-items-end gap-2">
            <app-button
              *appHasPermission="{ permissions: [permissions.allPermissions.DEVICE_IMPORT] }"
              id="startDeviceImport"
              buttonText="device_management.import.start_import"
              (click)="openStartImport()"
            ></app-button>
            <input
              pInputText
              type="text"
              (input)="filterGlobal(deviceTable, $event)"
              [placeholder]="translate.instant('common.search')"
            />
          </div>
        </ng-template>
        <ng-template #header let-columns>
          <tr>
            <th style="width: 2%"></th>
            <th></th>
            @for (col of columns; track col) {
              <th>
                {{ col.header | translate }}
              </th>
            }
          </tr>
          <tr>
            <th></th>
            <th>
              <p-checkbox binary="true" (onChange)="toggleSelectAllVisible($event.checked, deviceTable)"></p-checkbox>
            </th>
            <th>
              <p-columnFilter
                type="text"
                field="coreId"
                matchMode="contains"
                [showMenu]="false"
                filterOn="input"
                class="columnFilterFull"
              >
              </p-columnFilter>
            </th>
            <th>
              <p-columnFilter field="deviceType" [showMenu]="false" class="columnFilterFull">
                <ng-template #filter let-filter="filterCallback">
                  <p-select
                    class="w-full"
                    [showClear]="true"
                    [options]="deviceTypes()"
                    optionLabel="type"
                    (onChange)="filter($event.value?.type)"
                  >
                  </p-select>
                </ng-template>
              </p-columnFilter>
            </th>
            <th>
              <p-columnFilter field="tenant" [showMenu]="false" class="columnFilterFull" matchMode="in">
                <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                  <p-multiSelect
                    [ngModel]="value"
                    [options]="tenants()"
                    (onChange)="filter($event.value)"
                    [placeholder]="translate.instant('common.search')"
                    [maxSelectedLabels]="2"
                    [selectedItemsLabel]="'{0}' + ' ' + translate.instant('common.selected')"
                  >
                  </p-multiSelect>
                </ng-template>
              </p-columnFilter>
            </th>
            <th>
              <p-columnFilter field="softwareVersion" matchMode="equals" [showMenu]="false" class="columnFilterFull">
                <ng-template #filter let-filter="filterCallback">
                  <p-select
                    class="w-full"
                    [showClear]="true"
                    [options]="softwareVersionOptions()"
                    (onChange)="filter($event.value)"
                  >
                  </p-select>
                </ng-template>
              </p-columnFilter>
            </th>
            <th></th>
          </tr>
        </ng-template>
        <ng-template #body let-rowData let-columns="columns">
          <tr>
            <td>
              @if (rowData.status) {
                <div
                  class="dot OK"
                  [ngClass]="{
                    blink: rowData.status === deviceStatusOptions.UPDATING,
                  }"
                ></div>
              }
            </td>
            <td>
              <p-checkbox [(ngModel)]="rowData.selected" binary="true" />
            </td>
            @for (col of columns; track col) {
              <td>
                {{ rowData[col.field] }}
              </td>
            }
          </tr>
        </ng-template>
        <ng-template #footer>
          <tr>
            <td [attr.colspan]="devicesCols.length + 2">
              <div class="flex">
                <app-button
                  [disabled]="!checkSoftwareUpdate()"
                  buttonText="device_management.devices.start_update"
                  (click)="openUpdateDialog()"
                ></app-button>
              </div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    }
  </div>
  <ngx-simplebar class="widget flex flex-column p-4">
    <p-tabs [value]="allDeviceTypes.CORE" (valueChange)="changeTab($event)">
      <p-tablist>
        @for (tab of deviceTypesTabs(); track tab.value) {
          <p-tab [value]="tab.value">{{ tab.label }}</p-tab>
        }
      </p-tablist>

      <p-tabpanels>
        @for (tab of deviceTypesTabs(); track tab.value) {
          <p-tabpanel [value]="tab.value">
            <div class="list-compact-rows" style="padding: 0; max-height: 300px">
              <span class="listTitle">
                {{ "device_management.software.versions" | translate }}
              </span>
              <div class="listItems">
                @for (version of displayedSoftwareVersions(); track version) {
                  <div class="listRow">
                    <span>{{ version.version }}</span>
                    <div class="actionButtonGroup">
                      <app-svg-icon
                        *appHasPermission="{
                          permissions: [permissions.allPermissions.FIRMWARE_UPDATE],
                        }"
                        (click)="openSoftwareDialog(version)"
                        iconName="edit"
                        iconColor="primary"
                        iconSize="sm"
                      ></app-svg-icon>

                      <app-svg-icon
                        *appHasPermission="{
                          permissions: [permissions.allPermissions.FIRMWARE_DELETE],
                        }"
                        (click)="deleteSoftware($event, version)"
                        iconName="trash"
                        iconColor="primary"
                        iconSize="sm"
                      ></app-svg-icon>
                    </div>
                  </div>
                }
              </div>
            </div>
          </p-tabpanel>
        }
      </p-tabpanels>
    </p-tabs>
    <app-button
      style="position: sticky"
      buttonText="device_management.software.add_software"
      (click)="openSoftwareDialog(null)"
    >
    </app-button>
  </ngx-simplebar>
  <div class="widget flex flex-column p-4">
    <p-table [value]="deviceUpdates()" [scrollable]="true" scrollHeight="flex" [columns]="deviceUpdatesCols">
      <ng-template #caption let-columns>
        <div class="text-left w-full">
          {{ "device_management.updates.title" | translate }}
        </div>

        <div class="flex align-items-center w-full justify-content-between">
          <div class="flex flex-column">
            <label for="startDate">{{ "device_management.updates.from" | translate }}</label>
            <p-datePicker
              class="small"
              id="startDate"
              [(ngModel)]="startDate"
              dateFormat="dd.mm.yy"
              [firstDayOfWeek]="1"
              (onSelect)="onDateSelect()"
              appendTo="body"
            >
            </p-datePicker>
          </div>
          <div class="flex flex-column">
            <label for="endDate">{{ "device_management.updates.to" | translate }}</label>
            <p-datePicker
              class="small"
              id="endDate"
              [(ngModel)]="endDate"
              dateFormat="dd.mm.yy"
              [firstDayOfWeek]="1"
              (onSelect)="onDateSelect()"
              appendTo="body"
            >
            </p-datePicker>
          </div>
        </div>
      </ng-template>
      <ng-template #header let-columns>
        <tr>
          <th style="width: 2%"></th>
          @for (col of columns; track col) {
            <th>
              {{ col.header | translate }}
            </th>
          }
          <th></th>
        </tr>
      </ng-template>
      <ng-template #body let-rowData let-columns="columns">
        <tr>
          <td>
            <div
              class="dot"
              [ngClass]="{
                OK: rowData.status === updateStatus.STARTED || rowData.status === updateStatus.COMPLETE,
                CRITICAL: rowData.status === updateStatus.ABORTED,
                blink: rowData.status === updateStatus.STARTED,
              }"
            ></div>
          </td>
          @for (col of columns; track col) {
            @if (col.field === "startedAt") {
              <td>
                {{ rowData[col.field] * 1000 | date: "dd.MM.yyyy HH:mm" }}
              </td>
            } @else {
              <td>
                {{ rowData[col.field] }}
              </td>
            }
          }
          <td>
            @if (rowData.status === "STARTED") {
              <app-svg-icon
                iconName="trash"
                iconColor="primary"
                iconSize="sm"
                (click)="stopUpdate(rowData)"
              ></app-svg-icon>
            } @else {
              <app-svg-icon
                iconName="docs"
                iconColor="primary"
                iconSize="sm"
                (click)="getUpdateProtocol(rowData)"
              ></app-svg-icon>
            }
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
